import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private appConfig = inject(AppConfigService);
  private prefix = this.appConfig.dbName + '_';

  selectedFiltersSubject$ = new BehaviorSubject(JSON.parse(this.getItem('filter'))?.filters);
  selectedFirmIdsSubject$ = new BehaviorSubject(JSON.parse(this.getItem('firmIdList'))?.firmIdList);
  filterCountResultSubject$ = new BehaviorSubject(JSON.parse(this.getItem('filterCountResult')));
  selectedVariablesSubject$ = new BehaviorSubject(JSON.parse(this.getItem('variables'))?.variables || []);
  storedYearsSubject$ = new BehaviorSubject(JSON.parse(this.getItem('years'))?.years);
  selectedExtraOptionsSubject$ = new BehaviorSubject(JSON.parse(this.getItem('extra-options')));
  selectedDownloadOptionsSubject$ = new BehaviorSubject(JSON.parse(this.getItem('download-options')));
  selectedFileNameSubject$ = new BehaviorSubject(this.getItem('download-filename') || 'extract');
  firmsToValidateSubject$ = new BehaviorSubject(JSON.parse(this.getItem('firms-to-validate')));
  dbVersionSubject$ = new BehaviorSubject(JSON.parse(this.getItem('dbVersion')) || 'latest');

  // Catch ['undefined'] as selected variables in local storage
  constructor() {
    const selectedVariablesSnapShot = this.selectedVariablesSubject$.getValue();
    if (selectedVariablesSnapShot && selectedVariablesSnapShot.length > 0 && selectedVariablesSnapShot[0] == 'undefined') {
      this.setItem('variables', JSON.stringify({ variables: [] }));
      this.selectedVariablesSubject$.next([]);
    }
  }


  selectionCompleted$ = combineLatest([
    this.selectedFiltersSubject$,
    this.selectedFirmIdsSubject$,
    this.selectedVariablesSubject$,
    this.storedYearsSubject$,
    this.selectedExtraOptionsSubject$]).pipe(
    map(([filter, firmIdList, variables, years, extraOptions]) => {
      const firms = !!filter || !!firmIdList;
      const requiredSteps = [firms, variables, years];
      if (requiredSteps.every(step => !!step)) {
        return 'every';
      } else if ([...requiredSteps, extraOptions].some(step => !!step)) {
        return 'some';
      } else {
        return 'none';
      }
    })
  );

  getItem(name: string) {
    return localStorage.getItem(this.prefix + name);
  }

  setItem(name: string, value: string) {
    return localStorage.setItem(this.prefix + name, value);
  }

  setToken(value: string) {
    this.setItem('sequenza_token', value);
    this.setItem('sequenza_token_acquired_at', JSON.stringify(Date.now()));
  }

  removeItem(name: string) {
    return localStorage.removeItem(this.prefix + name);
  }

  parseQuery() {
    const filters = JSON.parse(this.getItem('filter'))?.filters;
    const variables = JSON.parse(this.getItem('variables'))?.variables;
    const years = JSON.parse(this.getItem('years'))?.years;
    const extraOptions = JSON.parse(this.getItem('extra-options'));
    const downloadOptions = JSON.parse(this.getItem('download-options'));
    const firmIdList = JSON.parse(this.getItem('firmIdList'))?.firmIdList;
    const filename = this.getItem('download-filename') || 'extract';
    const dbVersion = this.getItem('dbVersion') ? JSON.parse(this.getItem('dbVersion')) : 'latest';
    return {filters, variables, years, extraOptions, downloadOptions, firmIdList, dbVersion, filename};
  }
}
